export const TITLE_BAR_HEIGHT: string = '36px';
export const TASKBAR_HEIGHT: string = '36px';
